import React from "react";
import CustomPageHeader from "../fragments/CustomPageHeader";

export default function Charges({ children }) {
  return (
    <div>
      <CustomPageHeader icon='thumb-tack' text='Charges' />
      { children }
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/components/Charges/index.js